<div class="config-page">
  @if (!isRecuringEmpty) {
    <div *ngIf="!loading; else loadingTpl">
      @let involvedUsers = involvedUsers$ | async;
      @let queuedUsers = queuedUsers$ | async;

      <div class="config-card">
        <div class="config-header">
          <div class="config-title-row">
            <mat-icon class="header-icon accent">people</mat-icon>
            <span class="config-title">{{ 'Involved Users' | translate }}</span>
          </div>
          <button class="btn-edit" (click)="editIndividualRecurring()">
            <mat-icon class="btn-icon">edit</mat-icon>
            {{ 'Edit' | translate }}
          </button>
        </div>

        <div class="config-body">
          @if (involvedUsers && involvedUsers.length > 0) {
            <div class="user-list">
              @for (user of involvedUsers; track user.user_id) {
                <div class="user-item">
                  <mat-icon class="user-icon">person</mat-icon>
                  <span class="user-name">{{ user.fullname }}</span>
                </div>
              }
            </div>
          } @else {
            <p class="empty-state">{{ 'No users involved yet.' | translate }}</p>
          }
        </div>
      </div>

      @if (joinTheQueueFeature) {
        <div class="config-card">
          <div class="config-header">
            <div class="config-title-row">
              <mat-icon class="header-icon warning">hourglass_top</mat-icon>
              <span class="config-title">{{ 'Queued Users' | translate }}</span>
            </div>
            <button class="btn-edit" (click)="editQueueIndividualRecurring()">
              <mat-icon class="btn-icon">edit</mat-icon>
              {{ 'Edit' | translate }}
            </button>
          </div>

          <div class="config-body">
            @if (queuedUsers && queuedUsers.length > 0) {
              <div class="user-list">
                @for (user of queuedUsers; track user.user_id) {
                  <div class="user-item">
                    <mat-icon class="user-icon queued">hourglass_top</mat-icon>
                    <div class="user-info">
                      <span class="user-name">{{ user.fullname }}</span>
                      <span class="user-meta">{{ 'Joined' | translate }}: {{ user.joined_at | date: 'short' }}</span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-state">{{ 'No users in queue.' | translate }}</p>
            }
          </div>
        </div>
      }

      <div class="config-card danger-card">
        <div class="config-header">
          <div class="config-title-row">
            <mat-icon class="header-icon danger">cancel</mat-icon>
            <span class="config-title">{{ 'Cancel' | translate }}</span>
          </div>
        </div>
        <div class="config-body">
          <p class="card-description">{{ 'Cancel this individual recurring booking' | translate }}</p>
          <button class="btn-delete" (click)="canceIndividualRecurring()">
            {{ 'cancel booking' | translate }}
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="config-card">
      <div class="config-header">
        <div class="config-title-row">
          <mat-icon class="header-icon accent">people</mat-icon>
          <span class="config-title">{{ 'Involved Users' | translate }}</span>
        </div>
        <button class="btn-edit" (click)="editIndividualRecurringWithoutUsers()">
          <mat-icon class="btn-icon">edit</mat-icon>
          {{ 'Edit' | translate }}
        </button>
      </div>
      <div class="config-body">
        <p class="empty-state">{{ 'No users involved yet.' | translate }}</p>
      </div>
    </div>

    <div class="config-card danger-card">
      <div class="config-header">
        <div class="config-title-row">
          <mat-icon class="header-icon danger">cancel</mat-icon>
          <span class="config-title">{{ 'Cancel' | translate }}</span>
        </div>
      </div>
      <div class="config-body">
        <p class="card-description">{{ 'Cancel this individual recurring booking' | translate }}</p>
        <button class="btn-delete" (click)="canceIndividualRecurringWithoutUsers()">
          {{ 'cancel booking' | translate }}
        </button>
      </div>
    </div>
  }

  <ng-template #loadingTpl>
    <div class="loading-state">
      <mat-spinner diameter="36" />
    </div>
  </ng-template>
</div>
